(function() {
  'use strict';

  var track = document.querySelector('.clarisse-hp-results__track');
  var prev = document.querySelector('.clarisse-hp-results__arrow--prev');
  var next = document.querySelector('.clarisse-hp-results__arrow--next');

  if (!track) return;

  function getScrollAmount() {
    var card = track.querySelector('.clarisse-hp-results__card');
    if (!card) return 300;
    var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  if (prev) {
    prev.addEventListener('click', function() {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
  }

  if (next) {
    next.addEventListener('click', function() {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
  }
})();
